<template>
  <v-dialog v-model="dialog" width="500">
    <v-btn depressed small flat slot="activator" color="primary">
      <v-icon small>add</v-icon>
      {{ buttonTitle() }}
    </v-btn>

    <v-card tile flat>
      <v-toolbar tile flat card dense color="theme_primary" class="white--text">
        <v-spacer></v-spacer>
        <v-toolbar-title class="white-text text-capitalize"
          >Affiliate company</v-toolbar-title
        >

        <v-spacer></v-spacer>
        <v-toolbar-side-icon>
          <v-icon color="white">store</v-icon>
        </v-toolbar-side-icon>
      </v-toolbar>

      <v-card-text>
        <v-text-field
          v-model="affiliateCompany.name"
          required
          label="Name"
          autocomplete="affname"
          background-color="white"
          box
        />
        <v-text-field
          v-model="affiliateCompany.address1"
          required
          label="Address1"
          autocomplete="affadd1"
          background-color="white"
          box
        />
        <v-text-field
          v-model="affiliateCompany.address2"
          required
          label="Address2"
          autocomplete="affadd2"
          background-color="white"
          box
        />

        <v-autocomplete
          :items="countries"
          item-value="id"
          item-text="name"
          v-model="affiliateCompany.country_id"
          @change="affiliateCompany.city_id = ''"
          background-color="white"
          browser-autocomplete="noautocomplete"
          box
          label="Country"
        />

        <v-autocomplete
          :items="citiesFromCountry(affiliateCompany.country_id)"
          item-value="id"
          item-text="name"
          v-model="affiliateCompany.city_id"
          label="City"
          background-color="white"
          box
          browser-autocomplete="noautocomplete"
        >
          <template slot="selection" slot-scope="data">{{
            data.item.name
          }}</template>
          <template slot="item" slot-scope="data">{{
            data.item.name
          }}</template>
        </v-autocomplete>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="save" flat color="success" small>Save</v-btn>
        <v-btn @click="dialog = false" flat color="error" small>Cancel</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import CREATE_AFFILIATE_COMPANY from "../../graphql/affiliate_companies/create.gql";
import UPDATE_AFFILIATE_COMPANY from "../../graphql/affiliate_companies/update.gql";
import { mapGetters } from "vuex";

export default {
  props: {
    objectId: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      dialog: false,
      affiliateCompany: {},
    };
  },
  methods: {
    buttonTitle() {
      return this.objectId ? "Update" : "New Affiliate Company";
    },
    save() {
      this.dialog = false;
      this.affiliateCompany.company_id = this.$route.params.id;
      const name = "affiliate_company " + this.affiliateCompany.name;
      if (this.objectId) {
        this.sendMutation(
          "updated",
          name,
          UPDATE_AFFILIATE_COMPANY,
          this.affiliateCompany
        );
      } else {
        this.sendMutation(
          "created",
          name,
          CREATE_AFFILIATE_COMPANY,
          this.affiliateCompany
        ).then(() => {
          this.affiliateCompany = {};
        });
      }
    },
  },
  computed: {
    ...mapGetters("commonStore", ["countries", "cities", "citiesFromCountry"]),
    ...mapGetters("companyStore", ["newCompany", "getAffiliateCompany"]),
  },
  mounted() {
    if (this.objectId) {
      this.affiliateCompany = this.getAffiliateCompany(this.objectId);
    }
  },
};
</script>
